<template>
  <div class="inner">
    <div v-for="item in arr" :key="item.title">
      <div class="title">{{ item.title }}</div>
      <ul>
        <li
          v-for="item0 in moren"
          :key="item0.space_id"
          :class="{ act: item.name == 0 }"
        >
          <div class="djimg" @click="other(item0)">
            <img
              :src="item0.space_avatar"
              alt=""
              v-if="item0.space_avatar != ''"
            />
            <img src="../../assets/photoico.png" alt="" v-else />
          </div>
          <div>
            <p class="djimg" @click="other(item0)">{{ item0.space_name }}</p>
            <p>
              简介：
              <span v-if="item0.space_brief != ''">{{
                item0.space_brief
              }}</span>
              <span v-else>这位老师有点懒！！！</span>
            </p>
            <div>
              <span>粉丝 {{ item0.fanse_num }}</span>
              <span>|</span>
              <span>动态 {{ item0.dynamics_num }}</span>
              <span
                @click="guanzhuqh(item0)"
                :class="{ actives: item0.is_follow == 1 }"
              >
                {{ item0.is_follow == 0 ? "关注" : "已关注" }}
              </span>
            </div>
          </div>
        </li>
        <li
          v-for="item1 in moren"
          :key="item1.id"
          :class="{ act: item.name == 1 }"
        >
          <div class="djimg" @click="other(item1)">
            <img
              :src="item1.space_avatar"
              alt=""
              v-if="item1.space_avatar != ''"
            />
            <img src="../../assets/photoico.png" alt="" v-else />
          </div>
          <div>
            <p class="djimg" @click="other(item1)">{{ item1.space_name }}</p>
            <p>
              简介：
              <span v-if="item1.space_brief != ''">{{
                item1.space_brief
              }}</span>
              <span v-else>这位老师有点懒！！！</span>
            </p>
            <div>
              <span>粉丝 {{ item1.fanse_num }}</span>
              <span>|</span>
              <span>动态 {{ item1.dynamics_num }}</span>
              <span
                @click="guanzhuqh(item1)"
                :class="{ actives: item1.is_follow == 1 }"
              >
                {{ item1.is_follow == 0 ? "关注" : "已关注" }}
              </span>
            </div>
          </div>
        </li>
        <li
          v-for="item2 in banji"
          :key="item2.space_id"
          :class="{ act: item.name == 2 }"
        >
          <div class="djimg" @click="other(item2)">
            <img
              :src="item2.space_avatar"
              alt=""
              v-if="item2.space_avatar != ''"
            />
            <img src="../../assets/photoico.png" alt="" v-else />
          </div>
          <div>
            <p class="djimg" @click="other(item2)">{{ item2.space_name }}</p>
            <p>
              简介：
              <span v-if="item2.space_brief != ''">{{
                item2.space_brief
              }}</span>
              <span v-else>这位老师有点懒！！！</span>
            </p>
            <div>
              <span>粉丝 {{ item2.fanse_num }}</span>
              <span>|</span>
              <span>动态 {{ item2.dynamics_num }}</span>
              <span
                @click="guanzhuqh(item2)"
                :class="{ actives: item2.is_follow == 1 }"
              >
                {{ item2.is_follow == 0 ? "关注" : "已关注" }}
              </span>
            </div>
          </div>
        </li>
        <li
          v-for="(item3,index) in guanzhu"
          :key="index"
          :class="{ act: item.name == 3 }"
        >
          <div class="djimg" @click="other(item3)">
            <img
              :src="item3.space_avatar"
              alt=""
              v-if="item3.space_avatar != ''"
            />
            <img src="../../assets/photoico.png" alt="" v-else />
          </div>
          <div>
            <p class="djimg" @click="other(item3)">{{ item3.space_name }}</p>
            <p>
              简介：
              <span v-if="item3.space_brief != ''">{{
                item3.space_brief
              }}</span>
              <span v-else>这位老师有点懒！！！</span>
            </p>
            <div>
              <span>粉丝 {{ item3.fanse_num }}</span>
              <span>|</span>
              <span>动态 {{ item3.dynamics_num }}</span>
              <span
                @click="guanzhuqh(item3)"
                :class="{ actives: item3.is_follow == 1 }"
              >
                {{ item3.is_follow == 0 ? "关注" : "已关注" }}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import URL from "../../api/index";
export default {
  data() {
    return {
      arr: [
        { title: "热门搜索", name: "0" },
        { title: "默认空间", name: "1" },
        { title: "学校/班级空间", name: "2" },
        { title: "我的关注", name: "3" },
      ],
      UserInfo: "",
      getSpaceinfo: "",
      moren: "",
      banji: "",
      guanzhu: "",
    };
  },
  mounted() {
    this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    this.getSpaceinfo = JSON.parse(window.localStorage.getItem("getSpaceinfo"));
    this.mo_ren();
    this.guan_zhu();
  },
  methods: {
    other(e) {
      if (this.getSpaceinfo.space_id == e.space_id) {
        this.$router.push("/space/saying");
        return false;
      }
      localStorage.setItem("iteminfo", JSON.stringify(e));
      if (this.$route.path == "/space/saying") {
        this.reload();
      } else {
        this.$router.push("/space/saying");
      }
    },
    //默认、学校/班级、机构
    mo_ren() {
      var that = this;
      var getDefaultSpaceList_data = {
        token: that.UserInfo.token,
      };
      this.$post(URL.getDefaultSpaceList, getDefaultSpaceList_data).then(
        (res) => {
          this.moren = res.result.defaultSpace;
          this.banji = res.result.schoolSpace;
        
        }
      );
    },
    //关注
    guan_zhu() {
      var that = this;
      var getMyFollowSpace_data = {
        token: that.UserInfo.token,
        spacetype: "",
      };
      this.$post(URL.getMyFollowSpace, getMyFollowSpace_data).then((res) => {
        this.guanzhu = res.result.pace_list;
   
      });
    },
    guanzhuqh(e) {
      e.is_follow = e.is_follow == "0" ? "1" : "0";
      if (e.is_follow == "1") {
        var addMyFollowSpace_data = {
          token: this.UserInfo.token,
          space_id: e.space_id,
        };
        // 关注空间
        this.$post(
          URL.addMyFollowSpace,
          addMyFollowSpace_data
        ).then((res) => {});
      } else if (e.is_follow == "0") {
        var delMyFollowSpace_data = {
          token: this.UserInfo.token,
          space_id: e.space_id,
        };
        // 取消关注空间
        this.$post(
          URL.delMyFollowSpace,
          delMyFollowSpace_data
        ).then((res) => {});
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.djimg {
  cursor: pointer;
}
.inner {
  width: 1200px;
  margin: 0 auto 150px;
  .title {
    margin-top: 12px;
    line-height: 62px;
    font-family: MicrosoftYaHei;
    font-size: 18px;
    color: #4b4b4b;
  }
}
ul {
  overflow: hidden;
  padding: 1px;
  li {
    float: left;
    margin-right: 7px;
    width: 372px;
    padding: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(69, 69, 69, 0.14);
    display: none;
    margin-bottom: 25px;
    div {
      display: inline-block;
      &:first-child {
        float: left;
        img {
          width: 120px;
          height: 120px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      &:nth-child(2) {
        float: right;
        width: 65%;
        p {
          &:first-child {
            font-size: 16px;
            color: #4b4b4b;
            line-height: 34px;
          }
          &:nth-child(2) {
            font-size: 14px;
            line-height: 22px;
            margin: 5px 0;
            color: #898989;
            min-height: 46px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-box-orient: vertical;
          }
        }
        & > div {
          width: 100%;
          line-height: 30px;
          font-size: 12px;
          color: #3c495c;
          position: relative;
          span {
            &:nth-child(2) {
              margin: 0 15px;
            }
            &:last-child {
              display: inline-block;
              width: 4em;
              font-size: 14px;
              text-align: center;
              line-height: 26px;
              margin: auto;
              border-radius: 5px;
              border: 1px solid #409eff;
              color: #409eff;
              position: absolute;
              top: 50%;
              right: -8%;
              transform: translate(-50%, -50%);
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
.actives {
  background-color: #eee;
  border: none !important;
  color: #000 !important;
}
.act {
  display: block;
}
</style>
